// @flow
export { default, IntlPhoneInputStylingWrapper } from './IntlPhoneInput';
export type { Props } from './IntlPhoneInput';



// WEBPACK FOOTER //
// ../react-lib/src/components/formFields/IntlPhoneInput/index.js